import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { IFormGuard } from '../interface/IFormGuard';
import Swal from 'sweetalert2';
export const FormGuard: CanDeactivateFn<IFormGuard> =
  (
    component: IFormGuard,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot) => {
    if (!component.detectChange()) {
      return true;
    }
    return Swal.fire({
      title: 'Você tem certeza?',
      text: 'Você tem alterações não salvas. Tem certeza de que deseja sair?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, sair!',
      cancelButtonText: 'Não, ficar'
    }).then((result) => {
      if (result.isConfirmed) {
        return true;
      }
      return false;
    });
    // return component.detectChange();
  }
